'use client';

import { Button } from '@repo/ui/components/button';
import { cn } from '@repo/ui/lib/utils';
import { useAuth } from '@repo/ui/providers/auth-context';
import { User } from 'lucide-react';
import { useTranslations } from 'next-intl';
import React, { useState } from 'react';

import { Link } from '../../i18n/navigation';
import { Skeleton } from '../skeleton';
import { SignInDialog } from './sign-in-dialog';

export function AuthButton({
  className,
  onClick,
}: {
  className?: string;
  onClick?: () => void;
}) {
  const [showSignInDialog, setShowSignInDialog] = useState(false);
  const { user, isLoading } = useAuth();
  const t = useTranslations('auth');

  return (
    <>
      {isLoading ? (
        <Button variant='outline' className={cn('rounded-full', className)}>
          <User className='mr-2 h-4 w-4' />
          <Skeleton className='h-4 w-[45px]' />
        </Button>
      ) : user ? (
        <Link href='/profile' className={className}>
          <Button
            variant='outline'
            className={cn('rounded-full', className)}
            onClick={onClick}
          >
            <User className='mr-2 h-4 w-4' />
            {t('my_images')}
          </Button>
        </Link>
      ) : (
        <Button
          onClick={() => setShowSignInDialog(true)}
          variant='outline'
          className={cn('rounded-full', className)}
        >
          <User className='mr-2 h-4 w-4' />
          {t('sign_in')}
        </Button>
      )}

      <SignInDialog
        isOpen={showSignInDialog}
        onClose={() => setShowSignInDialog(false)}
      />
    </>
  );
}
